import React, { useState } from 'react';

import { convertToSeconds } from './TimeUtils';

const RunTime = ({ callback }) => {
    const [pace, setPace] = useState('5:00');
    const [unit, setUnit] = useState('km');

    const updatePace = value => {
        setPace(value);
        recalculate(value, unit);
    }

    const updateUnit = value => {
        setUnit(value);
        recalculate(pace, value);
    }

    const recalculate = (pace, unit) => {
        const seconds = convertToSeconds(pace);

        if (seconds > 0) {
            const adjustedSeconds = (unit === 'km') ? seconds : (seconds / 1.6);
            callback('run', adjustedSeconds);
        }
    }

    return (
        <div>
            <h2>Run time</h2>
            <label>
                <p>Enter your pace in m:ss format</p>
                <input
                    type="text"
                    value={pace}
                    onChange={event => updatePace(event.target.value)}
                /> 
            </label>
            <select value={unit} onChange={event => updateUnit(event.target.value)} ariaLabel="Unit">
                <option value="km">per km</option>
                <option value="mile">per mile</option>
            </select>
        </div>
    );
};

export default RunTime;
